var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreyt = function SvgGreyt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 38,
    viewBox: "0 0 80 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2699_122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V38H80V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2699_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7749 17.9964C31.7749 19.5759 30.4979 20.8547 28.9206 20.8547C27.3434 20.8547 26.0664 19.5759 26.0664 17.9964C26.0664 16.417 27.3434 15.1382 28.9206 15.1382C30.4979 15.1382 31.7749 16.417 31.7749 17.9964Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1422 2.85826C75.1422 4.43771 73.8651 5.71651 72.2879 5.71651C70.7106 5.71651 69.4336 4.43771 69.4336 2.85826C69.4336 1.27881 70.7106 0 72.2879 0C73.8651 0 75.1422 1.27881 75.1422 2.85826Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5054 10.0611C54.5054 11.6406 53.2284 12.9194 51.6511 12.9194C50.0739 12.9194 48.7969 11.6406 48.7969 10.0611C48.7969 8.48169 50.0739 7.20288 51.6511 7.20288C53.2284 7.20288 54.5054 8.48169 54.5054 10.0611Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2394 37.7036V35.506H63.9011V37.7036H62.5352V32.1438H63.9011V34.3076H66.2394V32.1438H67.5968V37.7036H66.2394Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3336 35.7939H69.9361V37.7036H68.5703V32.1438H71.3781C72.579 32.1438 73.3739 32.8764 73.3739 33.9604C73.3739 34.875 72.8116 35.5271 71.9151 35.7261L73.653 37.6994H72.0039L70.3294 35.7897L70.3336 35.7939ZM72.0335 33.9773C72.0335 33.5793 71.7206 33.3125 71.2301 33.3125H69.9361V34.6464H71.2301C71.7206 34.6464 72.0335 34.3796 72.0335 33.9731",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9865 15.1339C36.6395 15.1339 33.0664 18.3521 33.0664 23.065C33.0664 27.778 36.6395 30.9962 40.9569 30.9962C44.382 30.9962 47.0883 29.476 48.3695 26.3171L44.141 25.4533C43.3375 26.9142 42.0563 27.1809 40.9569 27.1809C39.35 27.1809 38.128 26.0757 37.7432 24.2888H48.6993V23.065C48.6105 18.1785 45.215 15.1339 40.9907 15.1339M37.8362 21.3628C38.2844 19.8426 39.6545 19.0084 40.9907 19.0084C42.3269 19.0084 43.5532 19.7537 43.9972 21.3628H37.8362Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9711 15.5828V10.5735H74.7324V15.5828H79.1386V19.3685H74.7324V24.5557C74.7324 26.1055 75.4766 26.7322 76.7283 26.7322C77.3837 26.7322 78.2759 26.495 78.9018 26.1351L80.0054 29.8911C78.8426 30.5178 77.6247 30.992 75.9249 30.992C72.2037 30.992 69.9711 28.9637 69.9711 25.0299V19.3642H65.345L57.4334 37.6994H52.3126L55.6193 30.0393L49.4414 15.5786H54.5622L58.0931 24.2846L61.8607 15.5786H69.9711V15.5828Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 30.5473H24.6094V28.1887V25.8683V18.4453V15.5828H19.8438V30.5473Z",
    fill: "#AA00EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9372 16.7769C10.7786 15.7352 9.2267 15.1382 7.29425 15.1382C3.33633 15.134 0 18.3564 0 23.0651C0 27.7738 3.33633 30.9962 7.29425 30.9962C9.23093 30.9962 10.7786 30.3992 11.9372 29.3575V30.3695C11.9372 32.7239 10.064 33.7994 7.92008 33.7994C6.37243 33.7994 5.5098 33.2913 4.40615 31.9532L0.448227 34.3965C1.90708 36.8101 4.49495 38.0042 7.92008 38.0042C12.7745 38.0042 16.7028 35.472 16.7028 30.848V15.5828H11.9372V16.7769ZM8.30488 25.9276C6.72763 25.9276 5.45061 24.6488 5.45061 23.0693C5.45061 21.4899 6.72763 20.2111 8.30488 20.2111C9.88213 20.2111 11.1592 21.4899 11.1592 23.0693C11.1592 24.6488 9.88213 25.9276 8.30488 25.9276Z",
    fill: "#AA00EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 38,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreyt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greyt.a67c16dc.svg";
export { ForwardRef as ReactComponent };